/**
 * Venue photography. Files in public/images are scale-only copies of the
 * owner-supplied original (the-grey-wolf-exterior.png): never edited.
 */
const base = `${process.env.PUBLIC_URL}/images/the-grey-wolf-exterior`;

export const exteriorPhoto = {
  src: `${base}-1280.jpg`,
  srcSet: `${base}-768.jpg 768w, ${base}-1280.jpg 1280w, ${base}-1625.jpg 1625w`,
  width: 1625,
  height: 968,
  alt:
    "Night-time exterior of Lyster's Pub in Harold's Cross, Dublin: gold LYSTER'S lettering above a black shopfront with The Grey Wolf sign (wood fired pizza, grill, burgers, döner kebab), festoon lights, hanging baskets and warmly lit windows.",
};
